import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "goods" }
const _hoisted_2 = {
  class: "goods-code",
  style: {"height":"234px","margin":"40px 0 20px 0"}
}
const _hoisted_3 = { class: "chart" }
const _hoisted_4 = { class: "chart-title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "btns" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "chart-content" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "echart",
    id: "echart-goods"
  })
], -1)

export function render(_ctx, _cache) {
  const _component_MiniTitle = _resolveComponent("MiniTitle")
  const _component_MoveTable = _resolveComponent("MoveTable")
  const _component_item = _resolveComponent("item")

  return (_openBlock(), _createBlock(_component_item, { title: "货物统计分析" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MiniTitle, { title: "货物代码及名称" }),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.data.length > 0)
            ? (_openBlock(), _createBlock(_component_MoveTable, {
                key: 0,
                style: {"height":"234px","margin":"0"},
                flex: [1,1],
                title: _ctx.title,
                data: _ctx.data
              }, null, 8, ["title", "data"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_MiniTitle, { title: "操作量" }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.chartType === '集装箱装卸量')
              ? (_openBlock(), _createElementBlock("h3", _hoisted_5, "总量：" + _toDisplayString(_ctx.value1), 1))
              : _createCommentVNode("", true),
            (_ctx.chartType === '件杂货操作量')
              ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "总量：" + _toDisplayString(_ctx.value2), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  class: _normalizeClass({active: _ctx.chartType === '集装箱装卸量'}),
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.chartTypeChanged('集装箱装卸量')))
                }, "集装箱装卸量", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({active: _ctx.chartType === '件杂货操作量'}),
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.chartTypeChanged('件杂货操作量')))
                }, "件杂货操作量", 2)
              ])
            ])
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _: 1
  }))
}